<template>
  <div class="footer-box">


  <van-tabbar v-model="type" @change="onChange" active-color="#037AFE" inactive-color="#999" style="height: 1.4rem;background: transparent;box-sizing: border-box; z-index: 200">
    <van-tabbar-item>
      <span class="foot-text">{{ $t('大厅') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab2-active.png?v=1' : '/static/image/new/tabbar/tab2.png?v=1'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span class="foot-text">{{ $t('客服') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab1-active.png?v=1' : '/static/image/new/tabbar/tab1.png?v=1'" />
      </template>
    </van-tabbar-item>

<!--    <van-tabbar-item>-->
<!--      <span class="foot-text">{{ $t('发现') }}</span>-->
<!--      <template #icon="props">-->
<!--        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab3-active.png' : '/static/image/new/tabbar/tab3.png'" />-->
<!--      </template>-->
<!--    </van-tabbar-item>-->

<!--    <van-tabbar-item>-->
<!--      <span class="foot-text">{{ $t('优惠') }}</span>-->
<!--      <template #icon="props">-->
<!--        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab4-active.png' : '/static/image/new/tabbar/tab4.png'" />-->
<!--      </template>-->
<!--    </van-tabbar-item>-->


    <van-tabbar-item>
      <span class="foot-text">{{ $t('我的') }}</span>
      <template #icon="props">
        <img :class="{no:!props.active}" :src="props.active ? '/static/image/new/tabbar/tab5-active.png?v=1' : '/static/image/new/tabbar/tab5.png?v=1'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  <!-- <div class="colosline"></div> -->
</div>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return {
      type: 0,
    };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        that.$parent.goNav(`/home`);
      }
      if (type == 1) {
        // that.$parent.goNav(`/activity`);
        that.$parent.goNav(`/dialogue`);
      }
      // if (type == 2) {
      //   // that.$parent.openKefu();
      //   that.$parent.goNav(`/discover`);
      // }
      // if (type == 3) {
      //   that.$parent.goNav(`/activity`);
      //
      //   // that.$parent.goNav(`/zhanzhu`);
      // }
      if (type == 2) {
        that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/dialogue') {
        that.type = 1;
      }
      if (path == '/home' || path == '/') {
        that.type = 0;
      }
      // if (path == '/discover') {
      //   that.type = 2;
      // }
      //
      // if (path == '/activity') {
      //   that.type = 3;
      // }
      if (path == '/mine') {
        // that.type = 4;
        that.type = 2;
      }
      // if (path == '/mine') {
      //   that.type = 4;
      // }
      // if (path == '/gamePage' || path == '/hongbao') {
      //   that.type = 5;
      // }
    },
  },
  mounted() {
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>
<style lang="scss">
.van-tabbar-item__text {
  width: 100% !important;
}
[class*=van-hairline]:after {
  opacity: 0;
  border: none;
}
</style>
<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
.van-tabbar-item__icon img {
  display: block;
  height: 20px;
  margin-bottom: 7px;
}

.van-tabbar-item__icon .no{
  height: 20px;
  margin-bottom: 7px;
}
.van-tabbar-item {
  font-size: 14px;
  width: calc(100% / 3);
}

.van-tabbar {
  height: 1.6rem;
}
.van-tabbar-item--active {
  background-color: transparent;
  color: #3E99FF !important;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    bottom: -0.05rem;
    left: 0;
    right: 0;
    height: .25rem;
    background-image: url("/static/image/new/tabbar/tabbar-active-bg.png");
    background-size: 100% 100%;
  }
}
.colosline{
    width: 100%;
    height: 2px;
    // background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
    background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.footer-box{
  font-family: PingFang SC;
  height: 1.53rem;
  position: fixed;
  bottom: .3rem;
  left: .4rem;
  right: .4rem;
  z-index: 300;
  flex-shrink: 0;
  max-width: 10rem;
  margin: auto;
  background: linear-gradient(180deg, #181A22 0%, #060608 100%);
  border: 0.5px solid #FFFFFF33;
  border-radius: .25rem;
  padding: 0 .3rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  .van-tabbar--fixed {
    position: relative !important;
  }
  .foot-text {
    width: 100%;
    font-size: .3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; //强制不换行
    display: inline-block;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue